import React, { useEffect, useState, useRef } from "react";
import QRCode from "react-qr-code";
import "./KanchiTable.css";

const FRONTEND_BASE_URL = "https://fliplyn-b-c-frontend.pages.dev/order";
const CAFE_ID = "e7b20008-f754-402a-944c-027bf11d68c0";
const API_URL = `https://fliplyn-b-c.fly.dev/cafes/${CAFE_ID}/tables`;

const CafeTablesQR = () => {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const qrRefs = useRef({});

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => {
        setTables(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching tables:", err);
        setLoading(false);
      });
  }, []);

  const downloadQR = (tableId, tableNumber) => {
    const svgElement = qrRefs.current[tableId];
    if (!svgElement) return;

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const img = new Image();
    img.onload = () => {
      canvas.width = 400;
      canvas.height = 400;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, 400, 400);

      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngFile;
      downloadLink.download = `Cafe-Table-${tableNumber}.png`;
      downloadLink.click();
    };

    img.src =
      "data:image/svg+xml;base64," +
      btoa(unescape(encodeURIComponent(svgData)));
  };

  const downloadAllQRs = () => {
    tables.forEach((table) => {
      downloadQR(table.id, table.table_number);
    });
  };

  if (loading) {
    return <div className="qr-page">Loading tables...</div>;
  }

  return (
    <div className="qr-page">
      <div className="qr-header">
        <h2>QR Code Management</h2>
        <button className="download-all-btn" onClick={downloadAllQRs}>
          Download All QRs
        </button>
      </div>

      <div className="qr-grid">
        {tables.map((table) => {
          // ✅ Correct production QR URL
          const qrValue = `${FRONTEND_BASE_URL}/${table.qr_code_token}`;

          return (
            <div className="qr-card" key={table.id}>
              <div className="qr-wrapper">
                <QRCode
                  value={qrValue}
                  size={200}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"
                  ref={(el) => (qrRefs.current[table.id] = el)}
                />
              </div>

              <div className="qr-details">
                <p><strong>Table Number:</strong> {table.table_number}</p>
                <p><strong>Status:</strong> {table.is_active ? "Active" : "Inactive"}</p>
                <p><strong>Scan URL:</strong></p>
                <small className="qr-url">{qrValue}</small>
                <p><strong>Created:</strong> {new Date(table.created_at).toLocaleString()}</p>
              </div>

              <button
                className="download-btn"
                onClick={() => downloadQR(table.id, table.table_number)}
              >
                Download QR
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CafeTablesQR;